var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ZendeskModel } from './shared/features/zendesk/zendesk.model';
var ZendeskConfig = /** @class */ (function (_super) {
    __extends(ZendeskConfig, _super);
    function ZendeskConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.accountUrl = 'biodigital.zendesk.com';
        return _this;
    }
    ZendeskConfig.prototype.beforePageLoad = function (zE) {
        zE.setLocale('en');
        zE.hide();
    };
    return ZendeskConfig;
}(ZendeskModel));
export { ZendeskConfig };
var ZendeskConfigModule = /** @class */ (function () {
    function ZendeskConfigModule() {
    }
    return ZendeskConfigModule;
}());
export { ZendeskConfigModule };
